import { madSDK } from "lib/sdk";

type SegmentInvalidationListener = () => void;

const listeners = new Set<SegmentInvalidationListener>();

/**
 * Subscribes to segment cache invalidations.
 * @returns an unsubscribe function.
 */
export const subscribeToSegmentInvalidation = (
  listener: SegmentInvalidationListener
): (() => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

/**
 * Drops every cached segment so the next read comes from the api. Segments
 * created outside the audience surfaces — publishing a Maverick AI persona, for
 * instance — are otherwise invisible until a full page reload, because
 * AudienceDataProvider holds its segments in app-level state.
 */
export const invalidateSegments = (): void => {
  madSDK.caches.clear("segments");
  listeners.forEach(listener => listener());
};
